import AnalyticsStore from '@store/analytics';

export const fetchAnalyticsCommon = async ({ dateFrom, dateTo, packs, }) => {
  const response = await AnalyticsStore.fetchAnalyticsCommon({ dateFrom, dateTo, packs, });

  return response;
};